import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "status-bar" }
const _hoisted_2 = ["href"]

import { useRoute, useRouter } from "vue-router";
import TimelineStep from "@/components/timeline/TimelineStep.vue";
import { useStore } from "vuex";
import { computed } from "vue";

interface Props {
  noticeReady?: boolean | undefined;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Declined',
  props: {
    noticeReady: { type: Boolean }
  },
  emits: ["downloadAdverseActionNotice"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const router = useRouter();
const route = useRoute();
const store = useStore();

const props = __props;

const collegeCounselorSchedulerUrl = computed<string>(() => store.state.configuration?.collegeCounselorSchedulerUrl);

function goToMyDocuments(query?: any) {
  router.push({
    name: "ApplicationDocuments",
    query: {
      ...route.query,
      ...query,
    },
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TimelineStep, {
      status: "declined",
      title: "Application Declined"
    }, {
      caption: _withCtx(() => [
        _createElementVNode("p", null, [
          _cache[0] || (_cache[0] = _createTextVNode(" Unfortunately, we were unable to approve your application. Thank you for giving us the opportunity to meet your education finance needs. For full details on your application decision, please refer to your Adverse Action Notice which may be accessed in the ", -1)),
          _createElementVNode("a", {
            class: "inline-link",
            onClick: goToMyDocuments
          }, "My Documents"),
          _cache[1] || (_cache[1] = _createTextVNode(" section of your applicant portal soon. ", -1))
        ]),
        _createElementVNode("p", null, [
          _cache[2] || (_cache[2] = _createTextVNode(" If you'd like to speak with our College Access Counselor to understand more about the decision, you can schedule a complimentary consultation ", -1)),
          _createElementVNode("a", {
            class: "inline-link",
            href: collegeCounselorSchedulerUrl.value,
            target: "_blank",
            "aria-description": "Link to schedule a complimentary consulation with the College Access Counselor"
          }, "here", 8, _hoisted_2),
          _cache[3] || (_cache[3] = _createTextVNode(". ", -1))
        ])
      ]),
      _: 1
    })
  ]))
}
}

})